/**
 * Cross-module X XWP-74 — every French string of the « nouvelle fenêtre » flow (CP §11, §15.20):
 * the question asked before opening, the band of the opened window and its fallback sentence.
 * Never a literal in a component.
 */

/** The sentence that says the source form stays as it is (one per source form, grammatical gender). */
export const PHRASES_SOURCE = Object.freeze({
  DEFAUT: "Votre saisie en cours reste ouverte dans cette fenêtre, telle quelle : rien n'est perdu ni enregistré.",
  ACHAT: "La facture en cours reste ouverte dans cette fenêtre, telle quelle : rien n'est perdu ni enregistré.",
  VENTE: "La vente en cours reste ouverte dans cette fenêtre, telle quelle : le panier est conservé.",
  AVOIR: "L'avoir en cours reste ouvert dans cette fenêtre, tel quel : rien n'est perdu ni enregistré.",
  BON_COMMANDE: "Le bon de commande en cours reste ouvert dans cette fenêtre, tel quel : rien n'est perdu ni enregistré.",
});

export const M_FENETRE = Object.freeze({
  // ── The question (source window) ──
  titre: (page) => `Ouvrir ${page} dans une nouvelle fenêtre ?`,
  pageParDefaut: "cette page",
  retourAide: "Dans la nouvelle fenêtre, « Retourner vers la fenêtre précédente » (Alt + W) vous ramène ici.",
  ouvrir: "Ouvrir dans une nouvelle fenêtre",
  annuler: "Annuler",
  /** Secondary choice of a menu link held by the unsaved-changes guard: the screen's own leave dialog. */
  quitterLaPage: "Quitter cette page…",
  /** S1's same-window round trip to the fiche produit (the facture is restored on return, WP-22). */
  ouvrirIciFacture: "Ouvrir ici, puis revenir à la facture",
  bloquee:
    "Le navigateur a bloqué la nouvelle fenêtre : autorisez les fenêtres de Pharmakon dans le navigateur, puis réessayez.",
  interdit: (page) => `Votre rôle ne donne pas accès à ${page}.`,
  // ── The band of the opened window ──
  bandeauLabel: "Fenêtre ouverte depuis une autre fenêtre",
  bandeau: (source) =>
    source ? `Fenêtre ouverte depuis « ${source} ».` : "Fenêtre ouverte depuis une autre fenêtre de Pharmakon.",
  retourner: "Retourner vers la fenêtre précédente",
  retournerCourt: "Retour",
  /** The fallback (XD-224): one clear sentence, nothing navigates. */
  sourceFermee: "La fenêtre précédente n'est plus ouverte : poursuivez dans cette fenêtre.",
  /** The source is open but this window still holds unsaved work: it stays open behind (XD-246). */
  resteOuverte: "La fenêtre précédente est au premier plan ; cette fenêtre reste ouverte car elle contient une saisie non enregistrée.",
});

/** The caisse's entry points (CaisseLibre: a line's « Stock & lots », the client's « Voir fiche »). */
export const M_FENETRE_CAISSE = Object.freeze({
  stockLigne: "Stock & lots",
  stockLigneAide: "Stock & lots de ce produit, dans une nouvelle fenêtre (Alt + K sur la ligne sélectionnée) — le ticket reste ouvert",
  stockLigneAria: (nom) => `Stock & lots de ${nom}, dans une nouvelle fenêtre`,
  voirFicheAide: "Fiche du client, dans une nouvelle fenêtre — le ticket reste ouvert",
});

export default M_FENETRE;
